import React, { useCallback, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import bikeDetails from '../../Assets/Images/bikeDetails.jpg'
import axios from 'axios'
import apiUrls from '../../Api/MainApi'
import moment from 'moment';
import { DatePicker, Select } from 'antd'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


function BikeDetails({ formData, setFormData }) {
    const [makeDropdown, setMakeDropDown] = useState([]);
    const [modelDropdown, setModelDropDown] = useState([]);
    const [variantDropdown, setVariantDropDown] = useState([]);
    const [fuelDropdown, setFuelDropdown] = useState([]);
    const [loading, setLoading] = useState(false);
    const [detailsID, setDetailsID] = useState({
        makeID: null,
        modelID: null,
        variantID: null
    });

    useEffect(() => {
        const fetchMakeData = async () => {
            const MakeResponse = await axios.post(apiUrls.GetMakeDropDown, {
                searchtext: formData.makeSearch,
                VehicleType: "Bike"
            });
            if (MakeResponse.data.status === 0) {
                const datas = MakeResponse.data.data;
                setDetailsID(prev => ({
                    ...prev,
                    makeID: datas.length > 0 ? datas[0].id : null
                }));
                setFormData(prev => ({
                    ...prev,
                    make: datas.length > 0 ? datas[0].id : null,
                    makeLabel: datas.length > 0 ? datas[0].name : null
                }));
            } else {
                console.log(MakeResponse.data, "error line");
            }
        };

        const fetchModelData = async (make) => {
            const ModelResponse = await axios.post(apiUrls.GetModelDropDown, { MakeID: make, searchtext: formData.modelSearch });
            const datas = ModelResponse.data.data;
            setDetailsID(prev => ({
                ...prev,
                modelID: datas.length > 0 ? datas[0].id : null
            }));
            setFormData(prev => ({
                ...prev,
                model: datas.length > 0 ? datas[0].id : null,
                modelLabel: datas.length > 0 ? datas[0].name : null
            }));
        };

        const fetchVariantData = async (make, model) => {
            const VariantResponse = await axios.post(apiUrls.GetVariantDropDown, { MakeID: make, MakeModelID: model, searchtext: formData.variantSearch });
            const datas = VariantResponse.data.data;
            setDetailsID(prev => ({
                ...prev,
                variantID: datas.length > 0 ? datas[0].id : null
            }));
            setFormData(prev => ({
                ...prev,
                variant: datas.length > 0 ? datas[0].id : null
            }));
        };

        const fetchData = async () => {
            if (formData.makeSearch && formData.modelSearch) {
                await fetchMakeData();
                if (formData.make) {
                    await fetchModelData(formData.make);
                }
                if (formData.make && formData.model) {
                    await fetchVariantData(formData.make, formData.model);
                }
            }
        };
        fetchData();
    }, [formData.makeSearch, setFormData, setDetailsID, detailsID.makeID, detailsID.modelID, formData.modelSearch, formData.make,
    formData.variantSearch, detailsID.variantID, formData.model]);

    const fetchMakeData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetMakeDropDown, {
                searchtext: '',
                VehicleType: "Bike"
            });
            setMakeDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchModelData = useCallback(async (make) => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetModelDropDown, { MakeID: make, searchtext: '' });
            setModelDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchVariantData = useCallback(async (make, model) => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrls.GetVariantDropDown, { MakeID: make, MakeModelID: model, searchtext: '' });
            setVariantDropDown(response.data.data);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchFuelData = useCallback(async () => {
        try {
            const response = await axios.get(apiUrls.GetFuelTypeDropDown);
            setFuelDropdown(response.data.data);
        } catch (error) {
            console.error('Failed to fetch fuel data:', error);
        }
    }, []);

    useEffect(() => {
        fetchMakeData();
        fetchFuelData();
    }, [fetchMakeData, fetchFuelData]);

    useEffect(() => {
        if (formData.make) {
            fetchModelData(formData.make);
        }
    }, [formData.make, fetchModelData]);

    useEffect(() => {
        if (formData.make && formData.model) {
            fetchVariantData(formData.make, formData.model);
        }
    }, [formData.make, formData.model, fetchVariantData]);

    const handleMakeChange = (selectedOption, option) => {
        setFormData(prev => ({
            ...prev,
            makeSearch: "",
            make: selectedOption,
            model: null,
            variant: null,
            makeLabel: option.label
        }));
    };

    const handleModelChange = (selectedOption, option) => {
        setFormData(prev => ({
            ...prev,
            modelSearch: "",
            model: selectedOption,
            variant: null,
            modelLabel: option.label
        }));
    };

    const handleVariantChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            variant: selectedOption
        }));
    };

    const handleFuelChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            fuel: selectedOption
        }));
    };

    const handleYearChange = (date, dateString) => {

        setFormData(prevData => ({
            ...prevData,
            year: dateString ? moment(dateString, 'DD-MM-YYYY').format('DD-MM-YYYY') : ''
        }));
    };
    const disabledDate = (current) => {    // to diable the date that is more than registration Date 
        if (formData.registrationInfo === 2) {
            return current && current > dayjs(formData.registrationDate, 'DD-MM-YYYY');
        }
        return false;
    }
    const defaultPickerValue = () => {  // to show the dates according to the registration info is present or not 
        if (formData.registrationInfo === 2 && formData.registrationDate) {
            return dayjs(formData.registrationDate, 'DD-MM-YYYY');
        }
        return undefined;
    }

    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (
        <>
            <div className='container'>
                <div className='row'>
                    <div className='mt-5'>
                        <div className='registration-location d-flex justify-content-between'>
                            <span className='mt-1'>Select Make</span>
                            <Select
                                name="Make"
                                showSearch
                                filterOption={filterOption}
                                value={formData.make}
                                onChange={handleMakeChange}
                                className="width-specifiying"
                                loading={loading}
                                options={(makeDropdown.length > 0 ? makeDropdown : [{ id: 0, name: "No Make Found" }]).map(make => ({ key: `make-${make.id}`, value: make.id, label: make.name }))}
                                placeholder="Select Make"
                                disabled={detailsID.makeID}
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Select Model</span>
                            <Select
                                name="Model"
                                showSearch
                                filterOption={filterOption}
                                value={formData.model}
                                onChange={handleModelChange}
                                className="width-specifiying"
                                options={(modelDropdown.length > 0 ? modelDropdown : [{ id: 0, name: "No Model Found" }]).map(model => ({ key: `model-${model.id}`, value: model.id, label: model.name }))}
                                placeholder="Select Model"
                                disabled={!formData.make || detailsID.modelID}
                                loading={loading}
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Select Variant</span>
                            <Select
                                name="Variant"
                                showSearch
                                filterOption={filterOption}
                                value={formData.variant}
                                onChange={handleVariantChange}
                                className="width-specifiying"
                                loading={loading}
                                options={(variantDropdown.length > 0 ? variantDropdown : [{ id: 0, name: "No Variant Found" }]).map(variant => ({ key: `variant-${variant.id}`, value: variant.id, label: variant.name }))}
                                placeholder="Select Variant"
                                disabled={!formData.model}
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Manufacturing year</span>
                            <DatePicker
                                defaultValue={formData.year ? dayjs(formData.year, 'DD-MM-YYYY') : null}
                                className='width-date'
                                onChange={handleYearChange}
                                format='DD-MM-YYYY'
                                disabledDate={disabledDate}
                                // defaultPickerValue={formData.registrationDate ? dayjs(formData.registrationDate, 'DD-MM-YYYY') : undefined}
                                defaultPickerValue={defaultPickerValue()}
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Fuel Type</span>
                            <Select
                                name="Fuel Type"
                                showSearch
                                filterOption={filterOption}
                                value={formData.fuel}
                                onChange={handleFuelChange}
                                loading={loading}
                                className="width-specifiying"
                                options={(fuelDropdown.length > 0 ? fuelDropdown : [{ id: 0, name: "No Fuel Found" }]).map(fuel => ({ key: `fuel-${fuel.id}`, value: fuel.name, label: fuel.name }))}
                                placeholder="Select Fuel Type"
                            />
                        </div>
                    </div>
                    {/* <div className='col-md-5'>
                        <div className='registration-image-div'>
                            <img src={bikeDetails} className='registration-image' alt=''></img>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default BikeDetails